import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_varga from "../../assets/img/face_balazs_varga.jpg";
import ShowMoreText from "react-show-more-text";
import proj_GNN_for_traffic_modelling from "../../assets/img/proj_GNN_for_traffic_modelling.png";

const Balazs_Varga_GNN_traffic = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_GNN_for_traffic_modelling} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_varga}
              /* ez a szöveg lesz majd a banneren */
              alt="Graph neural networks for traffic modelling"
            />{" "}
            <p className="text7">Balázs Varga</p>
            <br />
            <p className="text8">
              Research Fellow{" "}
            </p>
            <p className="text8">BME Traffic Lab </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Graph neural networks (GNNs) have emerged as state-of-the-art traffic 
            forecasting solutions because they are well suited for traffic systems 
            with graph structures. Road traffic networks can be naturally represented 
            as graphs, where nodes represent intersections or road segments, and edges 
            represent the connections between them (roads). GNNs capture spatial 
            dependencies and relationships between different parts of the road network.
            <br />
            <br />
            The goal of this research is to use microscopic traffic simulation (SUMO) 
            to generate large amounts of training data to train a GNN as a meta-model 
            of traffic simulation.
            <br />
            <br />
            Related literature:{" "}

            <ul>
                <li>
                Jiang, W. and Luo, J., 2022. Graph neural network for traffic forecasting: 
                A survey. Expert Systems with Applications, 207, p.117921.
                </li>
                <li>
                Lopez, P.A., Behrisch, M., Bieker-Walz, L., Erdmann, J., Flötteröd, Y.P., 
                Hilbrich, R., Lücken, L., Rummel, J., Wagner, P. and Wießner, E., 
                2018, November. Microscopic traffic simulation using sumo. In 2018 21st 
                international conference on intelligent transportation systems (ITSC) (pp. 2575-2582). IEEE.
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Varga_GNN_traffic;